var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('maptivateInfoButton',{attrs:{"isPopup":_vm.isPopup,"butType":"link","width":_vm.width,"color":_vm.appSettings.mediaButtonColor,"icon":'mdi-open-in-new',"title":_vm.title,"href":_vm.url,"target":"_blank"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }